import type { ReactNode } from "react";

export function QuotesSecondaryText({ children }: { children: ReactNode }) {
  return (
    <div className="text-[14px] font-light text-content-muted">{children}</div>
  );
}
